const chunkArray = (inputArray, itemsPerChunk) => {
  if (!Array.isArray(inputArray) || !Number.isInteger(itemsPerChunk)) {
    return null;
  }

  const result = inputArray.reduce((acc, item, index) => {
    const chunkIndex = Math.floor(index / itemsPerChunk);

    const resultArray = acc;

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []; // start a new chunk
    }

    resultArray[chunkIndex].push(item);

    return resultArray;
  }, []);

  return result;
};

export default chunkArray;
